//basic
import React from 'react';
import { toJS } from 'mobx';
import { observer, inject } from 'mobx-react';

//api
import { api } from '../../../functions/api';

//custom components
import CustomInput from '../../../components/basic/input';
import CustomButton from '../../../components/basic/CustomButton';
import SelectSearch from '../../../components/basic/SelectSearch/SelectSearch';

//material-ui
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, ListItem, CircularProgress } from '@material-ui/core';

//style
import './AddEditDynamicSet.scss';


@inject('translate')
@inject('internal')
@observer
export default class AddEditDynamicSet extends React.Component {
    constructor(props) {
        super(props);
        this.state={
            loading: true,
            loadingBtn: false,
            production: true,
            data: [],
            selected: [],
            name: "",
        }
    }

    isEditMode = null;

    componentDidMount () {
        this.isEditMode = toJS(this.props.internal.actionEdit);
        let listAllProducts = toJS(this.props.internal.dataForTable.lists.products) //pomocna premena kde ukladam data, potrebujem premenovat na value/label
        let newListProducts = []
        for(let product in listAllProducts) {
            newListProducts.push({
                value: listAllProducts[product].id,
                label: listAllProducts[product].name
            })
        }
        this.setState({data: newListProducts})

        if(this.isEditMode.edit) {
            //load detail fixneho setu
            this.loadDynamicSet()
        }
        else {
            this.setState({loading: false})
        }
    }

    fixedSetData = {}
    loadDynamicSet = async() => {
        let idFixedSet = toJS(this.props.internal.actionEdit.id)

        let load_fixed_set = await api({
            method: 'get',
            url: `products/dynamic-sets/${idFixedSet}`,
            authorization: this.props.internal.user.access_token,
        })

        if(load_fixed_set.success) {
            this.fixedSetData = load_fixed_set.data.data;
            let selected = load_fixed_set.data.data.products;
            for(let i in selected) {
                selected[i].label = selected[i].name
                selected[i].value = selected[i].id
            }
            this.setState({loading: false,
                name: load_fixed_set.data.data.name,
                discount: load_fixed_set.data.data.discount,
                selected: selected,
                production: load_fixed_set.data.data.production,
            })
        }
    }

    action = () => {
        let isEdit = toJS(this.props.internal.actionEdit.edit)
        this.setState({loadingBtn: true})
        if(isEdit) {
            //update
            this.updateDynamicSet()
        }
        else {
            //create
            this.createDynamicSet()
        }
    }

    updateDynamicSet = async() => {
        let name = this.name.state.value
        if(name !== "") {
            let idFixedSet = toJS(this.props.internal.actionEdit.id)

            // TODO: vymazat ked budu testovacie data
            // idFixedSet = 2;

            let update_data = await api({
                method: 'patch',

                // TODO: vymazat ked budu testovacie
                // postman: true,

                url: `products/dynamic-sets/${idFixedSet}`,
                authorization: this.props.internal.user.access_token,
                params: {
                    name: name,
                    production: this.state.production,
                    shop_id: this.props.shop_id
                }
            })
    
            if(update_data.success === true) {
                // this.props.internal.setSnackbar(update_data.data.message, true)
                // this.props.onClose(true)
                this.setProductsForDynamicSet(idFixedSet)
            }
        }
        else {
            this.props.internal.setSnackbar(this.props.translate.i18n.GLOBAL.ALERTS.FILL_REQUIRED_INPUTS, true)
        }
        
    }

    createDynamicSet = async() => {
        let name = this.name.state.value
        if(name !== "" ) {
            this.setState({loadingBtn: true})
            let update_data = await api({
                method: 'post',

                //TODO: vymazat ked bude testovaci server
                // postman: true,

                url: `products/dynamic-sets`,
                authorization: this.props.internal.user.access_token,
                params: {
                    name: name,
                    production: this.state.production,
                    shop_id: this.props.shop_id
                }
            })
    
            if(update_data.success === true || (update_data.success === false && update_data.status === 201)) {
                // this.props.internal.setSnackbar(update_data.data.message, true)
                this.setProductsForDynamicSet(update_data.data.data.id)
                // this.props.onClose(true)
            }
        }
        else {
            this.props.internal.setSnackbar(this.props.translate.i18n.GLOBAL.ALERTS.FILL_REQUIRED_INPUTS, true)
            this.setState({loadingBtn: false})
        }
        
    }

    setProductsForDynamicSet = async(idFixedSet) => {
        //TODO: vymazat ked budu na testovacom serveri
        // idFixedSet = 2

        let ids = this.state.selected;
        ids = ids.map(item => item.value)
        let update_data = await api({
            method: 'patch',

            //TODO: vymazat ked budu na testovacom serveri
            // postman: true,

            url: `products/dynamic-sets/${idFixedSet}/products`,
            authorization: this.props.internal.user.access_token,
            params: {
                ids: ids
            }
        })

        if(update_data.success === true) {
            this.setState({loadingBtn: false})
            this.props.internal.setSnackbar(update_data.data.message, true)
            this.props.onClose(true)
        }
    }

    handleChangeCheckbox = (event) => {
        this.setState({production: event.target.checked})
    }

    onSelectChange = (val) => {
        this.setState({selected: val})
    }

    render() {
        return (
            <Dialog
                open={this.props.open}
                onClose={() => this.props.onClose(false)}
                aria-labelledby="form-dialog-title"
                scroll={"body"}
                classes={{
                    root: "addEditFixedSetDialog-root",
                    paper: "addEditFixedSetDialog-paper"
                }}
            >
                <DialogTitle id="form-dialog-title">{this.props.title}</DialogTitle>
                {this.state.loading
                ?
                <div style={{minHeight: "100px"}}>
                    <CircularProgress className={'circular-progress'} />
                </div>
                :
                <DialogContent classes={{root: "add-fixed-set-content"}}>
                    
                    <CustomInput
                        ref={ref => this.name = ref}
                        text={this.props.translate.i18n.MODULES['FIXED-SETS'].TITLE}
                        // value={this.props.idCategory ? this.editCategory.name : ""}
                        // value=""
                        value={this.state.name}
                        id={'title'}
                        className={"w-100"}
                        // required
                    />
                    <SelectSearch
                        options={this.state.data}
                        // onChange={this.onParentSelectChange}
                        onChange={val => this.onSelectChange(val)}
                        value={this.state.selected}
                        className={'select-search'}
                        label={this.props.translate.i18n.MODULES['FIXED-SETS'].PRODUCTS}
                        isMulti={true}
                    />
                    <ListItem dense onChange={this.handleChangeCheckbox} className={'list-item'}>
                        <input
                            id={"production"}
                            type="checkbox"
                            value={this.state.production}
                            defaultChecked={
                                this.state.production
                            }
                        />
                        <label htmlFor={"production"}>{this.props.translate.i18n.GLOBAL.TABLE.ACTIVE}</label>
                    </ListItem>
                </DialogContent>
                }
                <DialogActions>
                    <Button onClick={() => this.props.onClose(false)} className={'gray-text'}>
                        {this.props.translate.i18n.GLOBAL.BUTTONS.CANCEL}
                    </Button>
                    <CustomButton
                        progressBar={this.state.loadingBtn}
                        onClick={this.action}
                        mystyle={'btn-white-bg'}
                        title={this.props.translate.i18n.GLOBAL.BUTTONS.SAVE}
                        justText
                        disabled={this.state.loading}
                    />
                </DialogActions>
            </Dialog>
        );
    }
}



// WEBPACK FOOTER //
// ./src/screens/dynamicSets/AddEdit/AddEditDynamicSet.jsx